export enum PokerCategory {
  ALL = 'All',
  STUD = 'Stud',
  OMAHA = 'Omaha',
  HOLDEM = 'Holdem',
  DRAW = 'Draw',
  CHINESE = 'Chinese',
  MIXED = 'Mixed',
  CUSTOM = 'Custom',
}
